import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { WebsitesState, SLICE_NAME } from './models';

const websitesSelector = (state: RootState): WebsitesState => state[SLICE_NAME];

export const selectWebsites = createSelector(websitesSelector, (state: WebsitesState) => state.websites);

export const selectWebsitesPagination = createSelector(websitesSelector, (state: WebsitesState) => state.pagination);

export const selectWebsitesIsLoading = createSelector(websitesSelector, (state: WebsitesState) => state.isLoading);

export const selectWebsitesError = createSelector(websitesSelector, (state: WebsitesState) => state.error);
